<template>
  <div>
    <px-view-header title="Solicitação de cotação" :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" link @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>
    <div v-if="loading" class="text-center">
      <px-circular-loading/>
    </div>
    <div v-if="!loading && solicitacao" class="mt-5">
      <px-cotacao-detalhes-basicos :is-painel="isPainel"
                                   :solicitacao="solicitacao"
                                   @update="onUpdate"/>
      <px-cotacao-detalhes-tabs class="mt-3"
                                :solicitacao="solicitacao"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { SituacaoSolicitacaoFrete } from 'px-business-components';
import CotacaoService from '../cotacoes-service';
import CotacaoDetalhesBasicos from './CotacaoDetalhesBasicos.vue';
import CotacaoDetalhesTabs from './CotacaoDetalhesTabs.vue';

export default {
  data() {
    return {
      id: this.$route.params.id,
      origin: this.$route.query.origin,
      back: this.$route.query.back,
      isPainel: false,
      loading: false,
      solicitacao: null,
      breadcrumbs: [
        { text: 'Negócios' },
        { text: 'Cotações' },
      ],
    };
  },
  computed: {
    ...mapGetters(['empresa', 'isPremium']),
  },
  methods: {
    onClickBack() {
      if (this.isPainel || this.back === 'PAINEL') {
        this.$router.push({ name: 'main.painel-cotacoes' });
        return;
      }
      this.$router.push({ name: 'main.cotacoes' });
    },
    onUpdate() {
      this.getSolicitacao();
    },
    getSolicitacao() {
      this.loading = true;
      CotacaoService.getSolicitacao(this.id)
        .then(({ data }) => {
          this.solicitacao = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCotacao() {
      this.loading = true;
      CotacaoService.getCotacao(this.id)
        .then(({ data }) => {
          this.solicitacao = {
            cotacaoFrete: data,
            situacao: SituacaoSolicitacaoFrete.keys.NAO_RESPONDIDA.key,
          };
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    if (this.origin === 'PAINEL') {
      this.isPainel = true;
      if (!this.isPremium) {
        this.onClickBack();
        return;
      }
      this.getCotacao();
      return;
    }
    this.getSolicitacao();
  },
  components: {
    pxCotacaoDetalhesBasicos: CotacaoDetalhesBasicos,
    pxCotacaoDetalhesTabs: CotacaoDetalhesTabs,
  },
};
</script>
